<div class="spinner-Overlay" *ngIf="displaySpinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
